import dayjs, {Dayjs} from 'dayjs';
import { axiosInstance } from '../Middleware';
export class FerieApi {
  public static listeFeries = async(dateDebut: Dayjs | Date, dateFin: Dayjs | Date) => {
    const debut = dayjs(dateDebut).format('YYYY-MM-DD');
    const fin = dayjs(dateFin).format('YYYY-MM-DD');
    return axiosInstance.get(`/personnel/personnel/feries/listeFeries?dateDebut=${debut}&dateFin=${fin}`)
      .then(response => response.data);
  };
}
